import { render } from "./DeLeche.vue?vue&type=template&id=371fd4e3"
import script from "./DeLeche.vue?vue&type=script&lang=js"
export * from "./DeLeche.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__